import { portalScreenContext } from '../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../app/telemetry/usePortalTelemetry';
import { Box, Grid, Paper, Typography } from "@mui/material";
import PaymentUnsuccessful from "../../app/components/PaymentUnsuccessful";
import { AppPathEnum } from "../../app/enums/appPathEnum";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { useEffect } from "react";

export default function DonationPaymentSuccessful() {
    const appInsights = useAppInsightsContext();
    const queryParams = new URLSearchParams(window.location.search);
    const responseCode = queryParams.get("Rc");
    const ref = encodeURIComponent(queryParams.get("ref") ?? '');
    const retryUrl = `${String(process.env.REACT_APP_REDIRECT_URI)}${AppPathEnum.DONATION_DASHBOARD}?ref=${ref}`;

    useEffect(() => {
        if (responseCode === "A") {
            appInsights.trackEvent({ name: "Donation - payment successful" });
        }
        else if (responseCode === "C") {
            appInsights.trackEvent({ name: "Donation - Payment cancelled" });
        }
        else {
            appInsights.trackEvent({ name: "Donation - payment unsuccessful" });
        }
    }, [appInsights, responseCode]);

    usePortalScreen(portalScreenContext('DonationPaymentSuccessful'), undefined, true);

        return (
        <>
            <Box sx={{ width: '100%' }} component={Paper}>

                <Grid container rowSpacing={4} sx={{ margin: "2%" }}>

                    <Grid size={{ xs: 12 }}></Grid>

                    {responseCode !== "C" && <>

                        <Grid size={{ xs: 12 }}>
                            <Typography variant='h4'>Payment successful</Typography>
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Typography variant='subtitle1'>
                                Thank you for your donation. Once you receive an email confirming payment,
                                please logout and login again to access your receipt.
                            </Typography>
                        </Grid>

                        <Grid size={{ xs: 12 }}></Grid>

                    </>}
                </Grid>

                {responseCode === "C" && retryUrl !== null && retryUrl !== '' &&
                    <Grid container rowSpacing={4} sx={{ marginLeft: '2%' }}>
                        <PaymentUnsuccessful retryUrl={retryUrl} />
                    </Grid>
                }

            </Box>
        </>
    )
}
